<template>

</template>

<script>
    export default {
        name: "ViewRawDBData"
    }
</script>

<style scoped>

</style>
